/**
 * Created by anthony on 11/18/14.
 */
stateProviders.push({
    name: 'schoolside.reports',
    url: '/reports',
    templateUrl: 'fast/submodules/schoolside/reports/partials/reports.html?v=' + versionNo,
    controller: 'ReportsController'
});
